import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};


export default function WebsiteDevelopment() {

    const websiteSteps = [
        { number: "01", title: "Consultation & Requirement Gathering", description: "We understand your business goals and target audience to plan your website effectively.", icon: "📤" },
        { number: "02", title: "Design & Prototype", description: "Our designers create visual mockups and interactive prototypes for approval.", icon: "⚡" },
        { number: "03", title: "Development & Testing", description: "We build your website using modern technology and rigorously test for speed, responsiveness, and functionality.", icon: "✓" },
        { number: "04", title: "Launch & Support", description: "We deploy your website and provide ongoing support, updates, and optimization.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Website Development Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional website development services in Los Angeles, CA. Build fast, responsive, and SEO-friendly websites for your business." />
                <meta name="keywords" content="website development services, web development Los Angeles, custom website development, business website development, web development near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Website Development</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Website Development</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/web1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Modern. Functional. Results-Driven.</span>
                                <h3 className="case-study-title">Expert Website Development in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we offer professional website development services in Los Angeles, California, helping businesses establish a strong online presence. A well-designed website is crucial for attracting new customers, building credibility, and increasing conversions. Our team combines creative design with technical expertise to deliver websites that are visually appealing, responsive, and fully optimized for performance.
                                </p>
                                <p className="case-study-description">
                                    Whether you need an e-commerce store, corporate website, portfolio, or blog, we develop custom website solutions that meet your specific business goals. Our developers ensure your website is fast-loading, mobile-friendly, and optimized for SEO, so you rank higher in search results. If you’re searching for website development near you in Los Angeles, Grand Indigo Embroidery is your trusted partner for reliable and professional web solutions.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Built for Performance & Growth</span>
                                <h3 className="case-study-title">Tailored Solutions for Businesses</h3>
                                <p className="case-study-description">
                                    We provide tailored website development services designed to fit your business needs. From UI/UX design to backend functionality and SEO-ready coding, we ensure your website engages visitors, improves user experience, and converts traffic into customers. Our team also integrates analytics, social media, and other essential tools to enhance your digital strategy. You can also order website development services online and get a fully functional, production-ready website tailored to your brand.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/web2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={websiteSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What types of websites do you develop?"
                                    answer="We develop e-commerce, corporate, portfolio, blog, and custom websites."
                                />

                                <FaqItem
                                    question="Do you provide website development services in Los Angeles?"
                                    answer="Yes, we offer professional website development services in Los Angeles, California, for local and online clients."
                                />

                                <FaqItem
                                    question="How long does a website development project take?"
                                    answer="Most projects are completed within 2–6 weeks depending on complexity and requirements."
                                />

                                <FaqItem
                                    question="Can I order website development services online?"
                                    answer="Yes, you can order website development services online and receive a fully functional website tailored to your business."
                                />

                                <FaqItem
                                    question="Are your websites SEO-friendly?"
                                    answer="Absolutely. We develop websites with SEO best practices to improve search rankings and online visibility."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
